import React, { useId } from 'react';
import './KpTextarea.css';

/**
 * KpTextarea – flerradig textruta i formulär (DS Del C .fi-textarea, Z5). Spec: docs/components/kp-textarea.md.
 *
 * Props:
 *  - value, onChange(value, event)
 *  - maxLength?: number       visar räknare "120 / 500" (gul från 90 %)
 *  - error?: string           felmeddelande under rutan (röd ram, aria-invalid)
 *  - short?: boolean          70 px i stället för 90 px (kommentarsfält)
 *  - id?, name?, placeholder?, rows?, disabled?, 'aria-label'?, 'aria-describedby'?, className?
 * Etiketten ligger utanför (Del C .fl) och kopplas med id.
 */
export default function KpTextarea({
  value = '',
  onChange,
  maxLength,
  error,
  short = false,
  id,
  name,
  placeholder,
  rows,
  disabled = false,
  'aria-label': ariaLabel,
  'aria-describedby': describedBy,
  className = '',
}) {
  const autoId = useId();
  const faltId = id || `kp-ta-${autoId}`;
  const felId = `${faltId}-fel`;
  const antal = String(value || '').length;
  const nara = typeof maxLength === 'number' && antal >= Math.floor(maxLength * 0.9);
  const beskrivning = [describedBy, error ? felId : null].filter(Boolean).join(' ') || undefined;
  const cls = ['kp-textarea', short ? 'kp-textarea--kort' : '', error ? 'kp-textarea--error' : '', className].filter(Boolean).join(' ');

  return (
    <div className="kp-textarea-wrap">
      <textarea
        id={faltId}
        name={name}
        className={cls}
        value={value}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-invalid={error ? true : undefined}
        aria-describedby={beskrivning}
        onChange={(e) => { if (typeof onChange === 'function') onChange(e.target.value, e); }}
      />
      {error || typeof maxLength === 'number' ? (
        <div className="kp-textarea-meta">
          {error ? <span id={felId} className="kp-textarea-fel" role="alert">{error}</span> : null}
          {typeof maxLength === 'number' ? (
            <span className={nara ? 'kp-textarea-raknare kp-textarea-raknare--nara' : 'kp-textarea-raknare'} aria-live="polite">
              {antal} / {maxLength}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
